import { RootState } from '@modules/App/redux/store';
import { PeerFormData } from '@modules/EvaluationModule/interfaces/PeerEvalData';
import { AsyncData } from '@shared/interfaces/asyncData';

export const peerEvalDataSelector = (state: RootState): AsyncData<PeerFormData> =>
  state.evaluation.peerEvalPage.peerEvalData;

export const peerEvalPermissionsSelector = (state: RootState) => state.evaluation.peerEvalPage.permissions;
